'use strict';

var inheritArray = require('inherit-array');

angular.module('far.gallery')
.service('gallery', function($http, $log) {

	function galleryProvider(term, id) {
		var factory = inheritArray(Gallery);

		return factory(term, id);
	}

	function Gallery(term, id) {
		var that = this;

		this.term = term;
		this.id = id;
		this.progress = true;
		this.save = function() {
			var serverData = this.slice();

			return $http.put(Routing.generate('api_gallery_put_gallery_object', {term: term, id: id}), serverData);
		};
		this.saveSort = function() {
			var serverData = this.slice();

			return $http.patch(Routing.generate('api_gallery_patch_gallery_object_sort', {term: term, id: id}), serverData);
		};

		$http.get(Routing.generate('api_gallery_get_gallery_object_items', {term: term, id: id}))
			.then(function(response) {
				response.data.items.forEach(function(item) {
					that.push(item);
				});

				that.progress = false;
			})
			.catch(function(response) {
				$log.error('Error to get gallery for ' + term + ' ' + id, response);
				that.progress = false;
			});
	}

	return galleryProvider;
});